// extracted by mini-css-extract-plugin
export default {"dropdown":"FilteringButton_dropdown__x-aIR"};